import { ChangeDetectionStrategy, Component, input } from '@angular/core';

/** Icons the panel can show. Kept as a closed set so the template can inline the SVG. */
export type ComingSoonIcon = 'image' | 'flag' | 'file-text';

/**
 * The "not built yet" panel.
 *
 * Deliberately distinct from an empty state: an empty state means "nothing matched", this means
 * "this feature is on its way". Conflating the two is how coming-soon starts reading as broken.
 */
@Component({
  selector: 'scr-coming-soon',
  changeDetection: ChangeDetectionStrategy.OnPush,
  templateUrl: './coming-soon.html',
})
export class ComingSoon {
  readonly heading = input.required<string>();
  readonly body = input<string>('');
  readonly badge = input<string>('In development');
  readonly icon = input<ComingSoonIcon>('image');
}
